














import { Component, Provide, Watch, Prop, Vue } from 'vue-property-decorator';
import { get } from 'lodash';

@Component
export default class ElementBlocInterpretation extends Vue {
  @Prop({ required: true, default: null }) acquisition!: any;
  @Prop({ required: true, default: 'walkingPhase' }) chartType!: string;
  @Prop({ default: true }) parameterInterpretation!: boolean;

  @Provide() chartsParameters: any = {
    walkingPhase: [],
    gaitLine: [],
    ratioPropulsion: [],
    prosupAngles: [],
    footProgressionAngle: [],
    clearanceSteppage: [],
  };

  get recommendations() {
    return (
      get(this.acquisition.computed_data, 'recommendations', false) &&
      get(this.acquisition.computed_data, 'recommendations.podosmart', false)
    );
  }
  get isLastRecommendations() {
    return this.recommendations && get(this.recommendations, 'clearance', false);
  }

  @Watch('acquisition', { deep: true, immediate: true })
  onAcquisitionChange() {
    this.chartsParameters.walkingPhase = [];
    this.chartsParameters.gaitLine = [];
    this.chartsParameters.ratioPropulsion = [];
    this.chartsParameters.prosupAngles = [];
    this.chartsParameters.footProgressionAngle = [];
    this.chartsParameters.clearanceSteppage = [];
    if (this.isLastRecommendations && this.parameterInterpretation) this.getParameters();
  }

  getParameters() {
    // Gait line
    if (this.chartType === 'gaitLine') {
      this.chartsParameters.gaitLine.push(this.recommendations.propulsion_time_percent);
      this.getRecommendations('gaitLine');
    }
    // Ratio proplusion
    if (this.chartType === 'ratioPropulsion') {
      this.chartsParameters.ratioPropulsion.push(this.recommendations.ratio_propulsion);
      this.getRecommendations('ratioPropulsion');
    }
    // Prono-supination angles
    if (this.chartType === 'prosupAngles') {
      this.getRecommendations('prosupAngles');
    }
    // Foot progression angle
    if (this.chartType === 'footProgressionAngle') {
      this.chartsParameters.footProgressionAngle.push(
        this.recommendations.foot_progression_angle_FF,
        this.recommendations.circumduction,
      );
      this.getRecommendations('footProgressionAngle');
    }
    // Clearance steppage
    if (this.chartType === 'clearanceSteppage') {
      this.chartsParameters.clearanceSteppage.push(
        this.recommendations.clearance,
        this.recommendations.plantar_flexion_angle_foot_in,
      );
      this.getRecommendations('clearanceSteppage');
    }
  }

  getRecommendations(parameter: string) {
    let index = 0;
    for (const data of this.chartsParameters[parameter]) {
      const hasLeft = get(data, 'left', false);
      const hasRight = get(data, 'right', false);
      const hasSymmetry = get(data, 'symmetry', false);

      let text = '';
      if (hasLeft && hasRight && hasLeft === hasRight) {
        text = `${this.getTranslate(data.left, 'symmetry')}`;
      }
      if (hasLeft && hasRight && hasLeft !== hasRight) {
        text = `${this.getTranslate(data.left, 'left')} - ${this.getTranslate(data.right, 'right')}`;
      }
      if (hasLeft && !hasRight) {
        text = `${this.getTranslate(data, 'left')}`;
      }
      if (!hasLeft && hasRight) {
        text = `${this.getTranslate(data, 'right')}`;
      }
      if (!hasLeft && !hasRight) {
        text = `${this.getTranslate(data, 'globals')}`;
      }

      this.chartsParameters[parameter][index] = {
        ...this.chartsParameters[parameter][index],
        text: text,
      };
      index++;
    }
  }

  getTranslate(code: string, type: string) {
    return this.$t(`interpretations.${type}.${code}`);
  }
  breakLine(val: string) {
    return val.replace(/(\r\n|\n)/g, '<br/>');
  }
}
